export const contacts = {
list: {
  count_other: "{{count}} جهة اتصال",
  count_many: "{{count}} جهة اتصال",
  count_few: "{{count}} جهات اتصال",
  count_two: "جهتا اتصال",
  count_one: "جهة اتصال واحدة",
  count_zero: "لا توجد جهات اتصال",
  csv: {
    scope: "من يمكنه رؤيتها",
    organisation: "المؤسسة",
    phone: "الهاتف",
    email: "البريد الإلكتروني",
    roles: "الأدوار",
    displayName: "الاسم المعروض",
  },
  insight: {
    signalOrgs_other: "{{count}} مؤسسة تنقصها بيانات.",
    signalOrgs_many: "{{count}} مؤسسة تنقصها بيانات.",
    signalOrgs_few: "{{count}} مؤسسات تنقصها بيانات.",
    signalOrgs_two: "مؤسستان تنقصهما بيانات.",
    signalOrgs_one: "مؤسسة واحدة تنقصها بيانات.",
    signalOrgs_zero: "لا توجد مؤسسة تنقصها بيانات.",
    signalSkills_other: "{{count}} مقاول بلا مهارات مسجلة.",
    signalSkills_many: "{{count}} مقاولًا بلا مهارات مسجلة.",
    signalSkills_few: "{{count}} مقاولين بلا مهارات مسجلة.",
    signalSkills_two: "مقاولان بلا مهارات مسجلة.",
    signalSkills_one: "مقاول واحد بلا مهارات مسجلة.",
    signalSkills_zero: "لا يوجد مقاول بلا مهارات.",
    signalVisible_other: "{{count}} جهة اتصال تطابق هذا العرض.",
    signalVisible_many: "{{count}} جهة اتصال تطابق هذا العرض.",
    signalVisible_few: "{{count}} جهات اتصال تطابق هذا العرض.",
    signalVisible_two: "جهتا اتصال تطابقان هذا العرض.",
    signalVisible_one: "جهة اتصال واحدة تطابق هذا العرض.",
    signalVisible_zero: "لا توجد جهات اتصال تطابق هذا العرض.",
    summaryMissing_other: "{{count}} جهة اتصال بلا بريد إلكتروني أو رقم هاتف.",
    summaryMissing_many: "{{count}} جهة اتصال بلا بريد إلكتروني أو رقم هاتف.",
    summaryMissing_few: "{{count}} جهات اتصال بلا بريد إلكتروني أو رقم هاتف.",
    summaryMissing_two: "جهتا اتصال بلا بريد إلكتروني أو رقم هاتف.",
    summaryMissing_one: "جهة اتصال واحدة بلا بريد إلكتروني أو رقم هاتف.",
    summaryMissing_zero: "كل جهات الاتصال لديها بريد إلكتروني أو رقم هاتف.",
    source: "جهات الاتصال التي يمكنك رؤيتها",
    metricSkillGaps: "بلا مهارات",
    metricMissingReach: "بلا بريد أو هاتف",
    metricVisible: "المعروض",
    signalOrgsOk: "لا توجد مؤسسة تنقصها بيانات.",
    signalSkillsOk: "لدى المقاولين المعروضين مهارات مسجلة.",
    summaryOk: "كل جهات الاتصال المعروضة لديها بريد إلكتروني أو رقم هاتف.",
    actionOrgs: "أكمل سجلات المؤسسات قبل التصدير أو إعداد التقارير.",
    actionSkills: "أضف مهارات المقاولين ليُقترح الأنسب لكل أمر عمل.",
    actionReach: "أضف بريدًا إلكترونيًا أو رقم هاتف لجهات الاتصال التي تسند إليها العمل.",
  },
  historySummary: "العمل المرتبط والملاحظات وروابط الدليل",
  untitledJob: "أمر عمل بلا عنوان",
  noLinkedSkills: "لا مهارات بعد",
  noRolesAssigned: "لا أدوار بعد",
  independentContact: "جهة اتصال مستقلة",
  kindInternal: "داخلي",
  noSkillMatches: "لا توجد مهارة مطابقة.",
  searchSkills: "البحث عن المهارات…",
  showingA11y: "المعروض: {{role}}. تغيير المرشح",
  roleAll: "الكل",
  noContacts: "لا توجد جهات اتصال",
  purpose: "جهات خارجية: المقاولون والموردون والعملاء",
  showMeHow: "أرني كيف",
  clearFilters: "مسح المرشحات",
  addContractor: "إضافة مقاول",
title: "جهات الاتصال",
addContact: "إضافة جهة اتصال",
loading: "جارٍ التحميل…",
emptyFilteredTitle: "لا توجد جهات اتصال مطابقة",
loadFailedTitle: "تعذّر تحميل جهات الاتصال",
loadUnavailableTitle: "جهات الاتصال غير متاحة",
emptyTitle: "لا توجد جهات اتصال بعد",
emptyFilteredSubtitle: "لا شيء يطابق هذه المرشحات. اضغط مسح المرشحات لرؤية الجميع.",
emptyContractorsTitle: "لا يوجد مقاولون بعد",
emptyContractorsSubtitle: "أضف مقاولًا لتسند إليه أوامر العمل أو تطلب منه عروض أسعار.",
visibilityGroupA11y: "من يمكنه رؤيتهم",
visibilityChip: {
  all: "الكل",
  team: "الفريق فقط",
  account: "مساحة العمل كاملة",
},
emptySubtitle: "أضف الأشخاص والشركات الذين تعمل معهم. يمكنك إسناد أوامر العمل إلى المقاولين الذين تضيفهم وطلب عروض أسعار منهم.",
importLabel: "استيراد",
},
shared: {
kindLabel: "نوع جهة الاتصال",
kind: {
person: "شخص",
organisation: "مؤسسة",
},
visibility: {
team: "فريقي فقط",
account: "الجميع في شركتي",
},
role: {
contractor: "مقاول",
landlord: "مالك عقار",
owner: "مالك",
client: "عميل",
agent_broker: "وكيل / سمسار",
tenant: "مستأجر",
supplier: "مورّد",
inspector: "مفتّش",
occupant: "ساكن",
driver: "سائق",
fleet_manager: "مدير الأسطول",
operator: "مشغّل",
engineer: "مهندس",
technician: "تقني",
other: "أخرى",
},
roleGroup: {
general: "عام",
property: "العقارات",
fleet: "الأسطول",
equipment: "المعدات",
},
roleDescription: {
contractor: "يمكنه استلام العمل وطلبات عروض الأسعار وتحديثات أوامر العمل.",
landlord: "يمثّل مالك العقار أو مجموعة الملكية.",
owner: "يملك الأصل أو المحفظة المرتبطة بجهة الاتصال هذه.",
client: "يطلب العمل، ويراجع النتائج، أو يوافق على الإصلاحات.",
agent_broker: "يتصرف بالنيابة عن المالك أو العميل أو المستأجر.",
tenant: "يسكن الأصل أو يستخدمه وقد يبلّغ عن المشكلات.",
supplier: "يوفّر المواد أو القطع أو الخدمات المتخصصة.",
inspector: "يجري التفتيشات أو المراجعات أو فحوصات الامتثال.",
occupant: "يعيش في الأصل أو يستخدمه أو مُعيَّن له.",
driver: "يقود أو مُعيَّن لمركبة في الأسطول.",
fleet_manager: "يدير المركبات والسائقين وعمليات الأسطول.",
operator: "يشغّل معدة أو مُعيَّن لها.",
engineer: "يصون المعدات أو يخدمها أو يصلحها.",
technician: "خدمة أو اختبار أو إصلاح عملي للمعدات.",
other: "استخدمه عندما لا يناسب أي دور آخر.",
},
primaryToggle: {
primary: "أساسي",
makePrimary: "تعيين كأساسي",
},
phoneType: {
mobile: "جوال",
work: "العمل",
home: "المنزل",
other: "أخرى",
},
},
create: {
  contractorEmailHint: "يحتاج المقاولون إلى بريد إلكتروني: تُرسل أوامر العمل وطلبات عروض الأسعار إليه.",
  headerSubtitleContractor: "شخص من خارج فريقك يمكنك إسناد أوامر العمل إليه أو طلب عروض أسعار منه.",
  headerTitleContractor: "مقاول جديد",
  visibilityEveryone: "يمكن للجميع في شركتك رؤية جهة الاتصال هذه.",
headerTitle: "جهة اتصال جديدة",
headerSubtitle: "أضف شخصًا أو مؤسسة إلى دليل حسابك.",
unnamedFallback: "جهة اتصال بلا اسم",
roleSummary: "{{role}} - {{description}}",
a11y: {
person: "جهة الاتصال شخص",
organisation: "جهة الاتصال مؤسسة",
},
alerts: {
  contractorEmailRequired: "أضف بريده الإلكتروني ليتلقى أوامر العمل وطلبات عروض الأسعار.",
  contractorEmailTitle: "أضف بريده الإلكتروني",
  createFailedTitle: "تعذّرت إضافة جهة الاتصال",
required: "أدخل اسمًا أو بريدًا إلكترونيًا أو رقم هاتف.",
noAccountTitle: "الحساب غير متاح",
noAccountBody: "انضم إلى حساب أو أنشئ واحدًا قبل إضافة جهات اتصال.",
createFailed: "تعذّرت إضافة جهة الاتصال هذه. حاول مرة أخرى بعد قليل.",
emailNeededTitle: "البريد الإلكتروني مطلوب للمشاركة",
emailNeededBody: "أضف عنوان بريد إلكتروني صالحًا؛ فبه تستلم جهة الاتصال الأصل المشترك.",
invalidPhoneTitle: "تحقق من رقم الهاتف",
invalidPhoneBody: "أدخل رقمًا صالحًا للبلد المحدد، أو اترك الهاتف فارغًا.",
},
sections: {
basicIdentityTitle: "الهوية الأساسية",
basicIdentityHelper: "من هي جهة الاتصال هذه وكيف يجب أن تظهر في دليلك.",
contactInfoTitle: "معلومات الاتصال",
contactInfoHelper: "كيف يمكن لفريقك التواصل معهم.",
whoIsThisTitle: "من هذا؟",
whoIsThisHelper: "اختر ما إذا كنت تضيف شخصًا أو مؤسسة.",
contactMethodTitle: "كيف نتواصل معهم؟",
contactMethodHelper: "أضف أفضل بريد إلكتروني ورقم هاتف للمتابعة.",
rolesWideTitle: "الأدوار والأنواع",
rolesWideHelper: "حدّد كل الأدوار التي تنطبق على جهة الاتصال هذه.",
visibilityWideTitle: "الظهور",
visibilityWideHelper: "اختر من يمكنه رؤية جهة الاتصال هذه واستخدامها.",
rolesTitle: "الأدوار",
rolesHelper: "حدّد كل الأدوار التي تنطبق على جهة الاتصال هذه.",
visibilityTitle: "الظهور",
visibilityHelper: "اختر من يمكنه رؤية جهة الاتصال هذه واستخدامها.",
detailsWideTitle: "تفاصيل إضافية",
skillsTitle: "المهارات",
skillsHelper: "تحدد المهارات أوامر العمل التي يمكن تعيين جهة الاتصال هذه لها ومن يُقترح لها.",
detailsTitle: "تفاصيل إضافية",
detailsHelper: "تفاصيل تجارية اختيارية.",
},
labels: {
displayName: "اسم العرض",
organisation: "اسم المؤسسة",
organisations: "المؤسسات",
company: "الشركة",
email: "البريد الإلكتروني",
phone: "الهاتف",
companyRegistrationNumber: "رقم تسجيل الشركة",
vatTaxNumber: "الرقم الضريبي / ضريبة القيمة المضافة",
notes: "ملاحظات",
skills: "المهارات",
},
placeholders: {
displayName: "مثال: أليكس المفتّش",
organisation: "مثال: Northside Property Group",
company: "مثال: Northside Services",
companyShort: "اسم الشركة (اختياري)",
email: "name@example.com",
phone: "أفضل رقم للتواصل",
companyRegistrationNumber: "رقم التسجيل (اختياري)",
vatTaxNumber: "الرقم الضريبي أو ضريبة القيمة المضافة (اختياري)",
notes: "ملاحظات خاصة",
},
visibility: {
team: "فريقي فقط",
account: "الجميع في شركتي",
},
skillsPicker: {
title: "مهارات جهة الاتصال",
hint: "اختر المهارات من كتالوج حسابك. تظهر على جهة الاتصال وفي المرشحات.",
},
actions: {
saving: "جارٍ الحفظ...",
submit: "إضافة جهة اتصال",
submitContractor: "إضافة مقاول",
dictate: "الإملاء الصوتي",
stopDictation: "إيقاف",
},
title: "إضافة جهة اتصال",
addedAs: "الإضافة بصفة",
nameLabel: "الاسم",
namePlaceholder: "الاسم الكامل",
emailLabel: "البريد الإلكتروني",
saveAndUse: "إضافة واستخدام جهة الاتصال",
quickCreate: {
  duplicateReason: {
    name: "الاسم نفسه",
    phone: "رقم الهاتف نفسه",
    email: "البريد الإلكتروني نفسه",
  },
closeA11y: "إغلاق إضافة جهة اتصال",
requiredToShareSuffix: " · مطلوب للمشاركة",
reviewPossibleMatch: "قم بمراجعة التطابق المحتمل",
discardTitle: "هل تريد تجاهل جهة الاتصال هذه؟",
discardBody: "لقد قمت بإدخال تفاصيل الاتصال التي لم يتم حفظها بعد.",
keepEditing: "استمر في التحرير",
discard: "تجاهل",
duplicateHeading: "جهة اتصال موجودة محتملة",
duplicateHint: "إعادة استخدام الهوية الموجودة عندما تكون نفس الشخص. لا يؤدي إنشاء سجل منفصل إلى دمج البيانات تلقائيًا.",
useExisting: "استخدم الموجود",
useExistingA11y: "استخدم جهة الاتصال الموجودة {{name}}",
createSeparate: "إنشاء جهة اتصال منفصلة",
createSeparateA11y: "إنشاء جهة اتصال منفصلة بعد مراجعة التكرار",
},
},
card: {
noDetails: "لا توجد بيانات اتصال",
invitedNotJoined: "مدعو · لم ينضم بعد",
email: "بريد إلكتروني",
call: "اتصال",
emailA11y: "مراسلة {{name}} بالبريد",
callA11y: "الاتصال بـ {{name}}",
roles: "الأدوار",
skills: "المهارات",
none: "لا شيء",
unlink: "إلغاء ربط {{name}}",
accessChange: "الوصول: {{label}}. تغيير",
access: {
requester: "يمكنه الطلب",
viewer: "يمكنه العرض",
none: "بدون وصول",
},
},
shareEdit: {
sendInvite: "إرسال دعوة",
resendInvite: "إعادة إرسال الدعوة",
sending: "جارٍ الإرسال…",
removeAccess: "إزالة الوصول",
},
detail: {
  inviterFallback: "شخص تعمل معه",
  noRolesYet: "لا دور بعد. اضغط تعديل واختر مقاول لتسند إليه أوامر العمل.",
  inviteNeedsEmail: "أضف عنوان بريد إلكتروني لدعوة {{name}}.",
  resendFailed: "تعذّرت إعادة إرسال الدعوة. حاول مرة أخرى بعد قليل.",
title: "جهة اتصال",
loadingMessage: "جارٍ تحميل تفاصيل الاتصال...",
noContactSelected: "لم يتم تحديد جهة اتصال",
contactNotFound: "لم يتم العثور على جهة الاتصال",
loadFailedTitle: "لم نتمكن من تحميل جهة الاتصال هذه",
loadUnavailableTitle: "لا يمكن عرض جهة الاتصال هذه",
goBack: "رجوع",
scopeTeamOnly: "فريقي فقط",
sectionOverview: "نظرة عامة",
sectionRoles: "الأدوار",
sectionContactDetails: "بيانات الاتصال",
sectionInvitations: "الدعوات والوصول",
sectionVisibility: "الظهور",
sectionTeamAccess: "وصول الفريق",
sectionSkills: "المهارات",
sectionHistory: "السجل",
labelType: "النوع",
labelName: "الاسم",
labelOrganisation: "مؤسسة",
labelCompany: "الشركة",
labelCompanyRegistrationNumber: "رقم تسجيل الشركة",
labelVatTaxNumber: "الرقم الضريبي / ضريبة القيمة المضافة",
labelStatus: "الحالة",
labelEmail: "البريد الإلكتروني",
labelPhone: "الهاتف",
labelAudience: "الجمهور",
labelOwningTeam: "الفريق المالك",
statusArchived: "مؤرشف",
statusActive: "نشط",
noEmailOrPhone: "لا يوجد بريد إلكتروني أو هاتف",
visibleToAllTeams: "يمكن للجميع في شركتك رؤية جهة الاتصال هذه.",
noSkillsAssigned: "لم يتم تعيين أي مهارات. قم بتحرير جهة الاتصال لإضافة علامات من كتالوج المهارات الخاصة بك.",
joinedApp: "انضمت جهة الاتصال هذه إلى التطبيق",
pendingInvites: "الدعوات المعلقة - يمكنهم استخدام الرابط لتسجيل الدخول",
noInvitesYet: "لا توجد دعوات حتى الآن",
inviteSent: "أُرسلت في {{date}}",
inviteExpires: "تنتهي صلاحيتها في {{date}}",
inviteStatus: {
pending: "معلّقة",
accepted: "مقبولة",
revoked: "ملغاة",
expired: "منتهية الصلاحية",
},
resend: "إعادة إرسال",
revoke: "سحب",
revokeInviteTitle: "إلغاء الدعوة",
revokeInviteMessage: "سيؤدي هذا إلى إلغاء الدعوة.",
cancel: "إلغاء",
edit: "تعديل",
editContactA11y: "تحرير جهة الاتصال",
contactAlreadyInApp: "جهة الاتصال موجودة بالفعل في التطبيق",
inviteContactToAppA11y: "دعوة جهة اتصال إلى التطبيق",
alreadyInApp: "موجود بالفعل في التطبيق",
inviteToApp: "دعوة إلى التطبيق",
invite: "دعوة",
share: "مشاركة",
shareWithTeam: "شارك مع الفريق",
shareContactWithTeamA11y: "مشاركة جهة الاتصال مع الفريق",
shareContactWithAnotherTeamA11y: "مشاركة جهة الاتصال مع فريق آخر",
promote: "مشاركة مع كل الفرق",
promoteToAccount: "مشاركة مع كل الفرق",
promoteContactToAccountA11y: "مشاركة جهة الاتصال هذه مع كل الفرق",
promoteContactVisibilityA11y: "مشاركة جهة الاتصال هذه مع كل الفرق",
archiveContact: "أرشفة جهة الاتصال",
archive: "أرشفة",
backToContactsListA11y: "العودة إلى قائمة جهات الاتصال",
contactsBreadcrumb: "جهات الاتصال",
noOtherTeamsTitle: "لا توجد فرق أخرى",
noOtherTeamsBody: "لا توجد فرق أخرى لمشاركة جهة الاتصال هذه معها.",
sharedTitle: "مشترك",
sharedBody: "تمت مشاركة جهة الاتصال مع {{team}}.",
fallbackTeam: "الفريق",
errorTitle: "لم ينجح ذلك",
failedToShare: "تعذّرت مشاركة جهة الاتصال. حاول مرة أخرى بعد قليل.",
promoteToAccountBody: "سيتمكن الجميع في شركتك من رؤية جهة الاتصال هذه.",
doneTitle: "تم",
promotedBody: "يمكن للجميع في شركتك الآن رؤية جهة الاتصال هذه.",
failedToPromote: "تعذّرت مشاركة جهة الاتصال مع كل الفرق. حاول مرة أخرى بعد قليل.",
invitationSentTitle: "تم إرسال الدعوة",
invitationSentBody: "تم إرسال بريد إلكتروني إلى {{email}}.",
invitationCreatedTitle: "حُفظت الدعوة ولم يُرسل البريد",
invitationCreatedBody: "حفظنا الدعوة لـ {{email}} لكن تعذّر إرسالها بالبريد الإلكتروني. اضغط إعادة الإرسال للمحاولة مرة أخرى.",
failedToCreateInvite: "تعذّر إنشاء الدعوة. حاول مرة أخرى بعد قليل.",
archiveContactTitle: "أرشفة جهة الاتصال",
archiveContactBody: "سيتم إخفاء جهة الاتصال هذه من القوائم. يمكنك الاستعادة لاحقًا إذا لزم الأمر.",
failedToArchive: "تعذّرت أرشفة جهة الاتصال. حاول مرة أخرى بعد قليل.",
invitesEmailResent: "تم الإرسال",
invitesEmailResentBody: "أُعيد إرسال رسالة الدعوة.",
inviteLinkUpdatedTitle: "لم يُرسل البريد",
inviteLinkUpdatedBody: "تعذّر إرسال الدعوة بالبريد الإلكتروني. اضغط إعادة الإرسال للمحاولة بعد قليل.",
timelineLoadingTitle: "جارٍ تحميل نشاط جهة الاتصال",
timelineErrorTitle: "النشاط غير مكتمل",
timelineEmptyTitle: "لا يوجد نشاط حتى الآن",
timelineLoadingSubtitle: "استرجاع العمل والمحفوظات المرتبطة.",
timelineErrorSubtitle: "لا يمكن تحميل بعض السجلات المرتبطة. أعد محاولة العمل المرتبط أعلاه.",
timelineEmptySubtitle: "ستظهر هنا المشاركات والطلبات وعمليات التفتيش وأوامر العمل والدعوات التي تتضمن {{name}}.",
accessLevel: {
view: "عرض",
edit: "تعديل",
manage: "إدارة",
},
},
edit: {
pageTitle: "تحرير جهة الاتصال",
noContactId: "لا يوجد معرف جهة اتصال",
contactNotFound: "لم يتم العثور على جهة الاتصال",
back: "رجوع",
kindA11yPerson: "نوع الاتصال: شخص",
kindA11yOrganisation: "نوع الاتصال: منظمة",
basicIdentityHelperWide: "شخص أو مؤسسة. مطلوب اسم العرض (أو الأول والأخير).",
displayNameLabel: "اسم العرض *",
displayNamePlaceholder: "الاسم المعروض في القوائم",
displayNameA11yWide: "اسم العرض، مطلوب",
displayNameA11yNarrow: "اسم العرض (مطلوب)",
firstNameLabel: "الاسم الأول",
firstNamePlaceholder: "الاسم الأول",
lastNameLabel: "اسم العائلة",
lastNamePlaceholder: "اسم العائلة",
organisationsLabel: "المؤسسات",
contactInfoHelper: "يُستخدم للدعوات والمتابعة.",
emailLabel: "البريد الإلكتروني",
emailPlaceholder: "email@example.com",
emailA11yWide: "عنوان البريد الإلكتروني",
phoneLabel: "الهاتف",
whoIsThisHelperNarrow: "شخص أو مؤسسة. الاسم مطلوب، والمؤسسة تساعد على فهم السياق.",
contactMethodHelperNarrow: "يساعدك البريد الإلكتروني أو الهاتف على الوصول إليهم لاحقًا.",
rolesTitleWide: "الأدوار والأنواع",
rolesTitleNarrow: "ما صلتهم بنا؟",
rolesHelper: "اختر دورًا واحدًا أو أكثر حتى تظهر جهة الاتصال هذه في التدفقات الصحيحة.",
visibilityHelperWide: "فريقي فقط: يرى فريقك وحده جهة الاتصال هذه. الجميع في شركتي: تراها كل الفرق.",
visibilityTitleNarrow: "من يمكنه استخدام جهة الاتصال هذه؟",
visibilityHelperNarrow: "يراها فريقك وحده ما لم تختر الجميع في شركتي. يمكنك مشاركتها مع كل الفرق لاحقًا.",
visibilityA11yTeam: "الظهور: فريقي فقط",
visibilityA11yAccount: "الظهور: الجميع في شركتي",
vatA11y: "ضريبة القيمة المضافة أو الرقم الضريبي",
notesTitleWide: "ملاحظات",
notesTitleNarrow: "تفاصيل اختيارية",
notesHelper: "الملاحظات خاصة بفريقك.",
improving: "جارٍ التحسين...",
improveWithAi: "تحسين باستخدام الذكاء الاصطناعي",
addNotesFirstTitle: "أضف الملاحظات أولاً",
addNotesFirstBody: "اكتب مسودة قصيرة أو أملِها، ثم استخدم «تحسين باستخدام الذكاء الاصطناعي».",
unableToImproveNotesTitle: "غير قادر على تحسين الملاحظات",
improveNotesFailed: "تعذر تحسين الملاحظات. يرجى المحاولة مرة أخرى.",
tidiedNotesTitle: "ملاحظات مرتبة",
tidiedNotesRationale: "قم بمراجعة الملاحظات المرتبة قبل تطبيقها.",
saveChanges: "حفظ التغييرات",
saving: "جارٍ الحفظ…",
requiredTitle: "مطلوب",
requiredNameBody: "أدخل اسمًا: اسم العرض أو الاسم الأول والأخير أو اسم المؤسسة.",
workspaceChangedError: "تم تغيير مساحة العمل الخاصة بك. أعد فتح جهة الاتصال قبل المتابعة.",
updateFailed: "تعذّر حفظ تغييراتك. حاول مرة أخرى بعد قليل.",
},
import: {
  actions: {
    addManually: "إضافة يدويًا",
    phonePicker: "منتقي الهاتف",
    uploadFile: "رفع ملف",
  },
  access: {
    whyLine: "يقرأ AssetWRX جهات اتصالك فقط لتختار من تضيف.",
    deniedTitle: "الوصول إلى جهات الاتصال متوقف",
    deniedBody: "اسمح بالوصول لرؤية جهات اتصال هاتفك هنا. لا يزال بإمكانك إضافة الأشخاص يدويًا أو بمنتقي الهاتف.",
    allow: "السماح بالوصول",
    openSettings: "فتح الإعدادات",
    limited: "شاركت بعض جهات الاتصال فقط مع AssetWRX. استخدم منتقي الهاتف لإضافة الآخرين.",
    unavailableTitle: "جهات اتصال هاتفك غير متاحة هنا",
    unavailableBody: "يعمل الاستيراد من جهات الاتصال في تطبيق iOS وAndroid. هنا يمكنك إضافة الأشخاص يدويًا أو رفع ملف.",
  },
  list: {
    searchA11y: "البحث في جهات الاتصال",
    searchPlaceholder: "ابحث بالاسم أو الشركة أو البريد أو الهاتف",
    count_zero: "لا جهات اتصال على هذا الهاتف",
    count_one: "جهة اتصال واحدة على هذا الهاتف",
    count_two: "جهتا اتصال على هذا الهاتف",
    count_few: "{{count}} جهات اتصال على هذا الهاتف",
    count_many: "{{count}} جهة اتصال على هذا الهاتف",
    count_other: "{{count}} جهة اتصال على هذا الهاتف",
    loading: "جارٍ تحميل جهات اتصالك…",
    emptyTitle: "لا جهات اتصال على هذا الهاتف",
    emptyBody: "أضف الأشخاص يدويًا، أو استخدم منتقي الهاتف إذا كانت جهات اتصالك في تطبيق آخر.",
    noMatchTitle: "لا أحد يطابق «{{query}}»",
    noMatchBody: "تحقق من الإملاء، أو ابحث بالشركة أو البريد أو الهاتف.",
    alreadyAdded: "موجود بالفعل في AssetWRX",
    reviewA11y: "راجع {{name}} قبل الإضافة",
    selectA11y: "تحديد {{name}}",
    selectAll: "تحديد الكل ({{total}})",
    clearSelection: "مسح التحديد",
    import: "استيراد",
    importCount_zero: "استيراد",
    importCount_one: "استيراد واحدة",
    importCount_two: "استيراد اثنتين",
    importCount_few: "استيراد {{count}}",
    importCount_many: "استيراد {{count}}",
    importCount_other: "استيراد {{count}}",
  },
  confirm: {
    title_zero: "لا جهات اتصال للإضافة",
    title_one: "إضافة جهة اتصال واحدة",
    title_two: "إضافة جهتي اتصال",
    title_few: "إضافة {{count}} جهات اتصال",
    title_many: "إضافة {{count}} جهة اتصال",
    title_other: "إضافة {{count}} جهة اتصال",
    subtitle: "من جهات اتصال هاتفك",
    alreadyNote_zero: "لا أحد منهم موجود في AssetWRX.",
    alreadyNote_one: "واحد منهم موجود بالفعل في AssetWRX وستتم إضافته مرة أخرى.",
    alreadyNote_two: "اثنان منهم موجودان بالفعل في AssetWRX وستتم إضافتهما مرة أخرى.",
    alreadyNote_few: "{{count}} منهم موجودون بالفعل في AssetWRX وستتم إضافتهم مرة أخرى.",
    alreadyNote_many: "{{count}} منهم موجودون بالفعل في AssetWRX وستتم إضافتهم مرة أخرى.",
    alreadyNote_other: "{{count}} منهم موجودون بالفعل في AssetWRX وستتم إضافتهم مرة أخرى.",
    roleLabel: "الدور",
    roleHelper: "اختياري. ينطبق على كل من تضيفهم، ويمكنك تغييره لاحقًا.",
    visibilityLabel: "من يمكنه رؤيتهم",
    privacy: "أضف فقط الأشخاص الذين تعمل معهم. سيكونون مرئيين لـ {{audience}}.",
    audienceTeam: "فريقك",
    audienceAccount: "كل من في شركتك",
    cancel: "إلغاء",
    confirm_zero: "إضافة",
    confirm_one: "إضافة واحدة",
    confirm_two: "إضافة اثنتين",
    confirm_few: "إضافة {{count}}",
    confirm_many: "إضافة {{count}}",
    confirm_other: "إضافة {{count}}",
    progress: "جارٍ إضافة {{done}} من {{total}}…",
    closeA11y: "إغلاق",
  },
  notes: {
    jobTitle: "المسمى الوظيفي: {{value}}",
    otherEmails: "عناوين بريد أخرى: {{value}}",
  },
  alerts: {
    readFailedTitle: "تعذر قراءة جهات الاتصال",
    readFailedDefaultBody: "حاول مرة أخرى، أو استخدم منتقي الهاتف لإضافة الأشخاص واحدًا تلو الآخر.",
    pickerFailedTitle: "تعذر فتح منتقي جهات الاتصال",
    pickerFailedDefaultBody: "قم بمنح جهات الاتصال حق الوصول في الإعدادات وحاول مرة أخرى.",
    invalidContactTitle: "جهة اتصال غير صالحة",
    invalidContactBody: "لا تحتوي جهة الاتصال هذه على معلومات قابلة للاستخدام. الرجاء تحديد آخر.",
    noAccountTitle: "لا يوجد حساب",
    noAccountBody: "يجب أن تكون في حساب لإضافة جهات اتصال.",
    stoppedTitle: "توقف الاستيراد",
    stoppedWithProgress: "تمت إضافة {{count}} قبل حدوث خطأ: {{error}}",
    unknownError: "خطأ غير معروف",
    completeBody_one: "تمت إضافة جهة اتصال واحدة.",
    completeBody_other: "تمت إضافة {{count}} جهة اتصال.",
    completeBody_zero: "لم تتم إضافة أي جهة اتصال.",
    completeBody_two: "تمت إضافة جهتَي اتصال.",
    completeBody_few: "تمت إضافة {{count}} جهات اتصال.",
    completeBody_many: "تمت إضافة {{count}} جهة اتصال.",
  },
  review: {
    requiredTitle: "مطلوب",
    requiredBody: "أدخل اسمًا.",
    errorTitle: "خطأ",
    errorDefaultBody: "فشل في إنشاء جهة اتصال.",
    noContactSelected: "لم يتم تحديد جهة اتصال. ارجع واختر واحدًا من هاتفك.",
    backToContacts: "العودة إلى جهات الاتصال",
    nameSectionTitle: "الاسم *",
    nameA11y: "الاسم (مطلوب)",
    namePlaceholder: "اسم العرض",
    companyA11y: "الشركة (اختياري)",
    companyPlaceholder: "الشركة (اختياري)",
    notesA11y: "ملاحظات (اختياري)",
    notesPlaceholder: "ملاحظات خاصة (اختياري)",
    visibilitySectionTitle: "من يمكنه استخدام جهة الاتصال هذه؟",
    skillsSectionTitle: "المهارات",
    skillsPickerHint: "اختياري: قم بإرفاق مهارات الكتالوج بجهة الاتصال المستوردة هذه.",
    nameLabel: "الاسم",
    companyLabel: "الشركة",
    notesLabel: "ملاحظات",
    rolesSectionTitle: "الدور",
    moreDetails: "مزيد من التفاصيل",
    fewerDetails: "تفاصيل أقل",
    extraPhones_zero: "لا أرقام إضافية: {{numbers}}",
    extraPhones_one: "يضيف أيضًا رقمًا آخر: {{numbers}}",
    extraPhones_two: "يضيف أيضًا رقمين آخرين: {{numbers}}",
    extraPhones_few: "يضيف أيضًا {{count}} أرقام أخرى: {{numbers}}",
    extraPhones_many: "يضيف أيضًا {{count}} رقمًا آخر: {{numbers}}",
    extraPhones_other: "يضيف أيضًا {{count}} رقم آخر: {{numbers}}",
    existingTitle: "موجود بالفعل في AssetWRX باسم {{name}}",
    existingOpen: "فتح",
    save: "حفظ",
    saveAndAnother: "حفظ وإضافة آخر",
    addedToast: "تمت إضافة {{name}}",
  },
},
picker: {
  createNamed: "إنشاء «{{search}}»",
defaultTitle: "حدد جهة الاتصال",
closeA11y: "إغلاق منتقي جهات الاتصال",
searchPlaceholder: "ابحث عن الاسم أو الشركة أو البريد الإلكتروني أو الدور...",
searchA11y: "البحث في جهات الاتصال",
scope: {
all: "الكل",
team: "الفريق فقط",
account: "مساحة العمل كاملة",
},
sections: {
recommended: "موصى به لهذا العمل",
recent: "الأخيرة",
searchResults: "نتائج البحث",
allContacts: "جميع جهات الاتصال",
},
searching: "جارٍ البحث...",
empty: {
  noMatch: "لا يوجد أحد باسم «{{search}}» بعد.",
  noneNoCreate: "لا توجد جهات اتصال بعد.",
  none: "لا توجد جهات اتصال بعد. اضغط {{label}}.",
skillsScoped: "لا توجد جهات اتصال {{scope}} تتطابق مع هذه المهارات. إظهار كافة جهات الاتصال، أو إيقاف تشغيل عامل تصفية المهارات.",
searchScoped: "لا توجد جهات اتصال {{scope}} تطابق بحثك. إظهار جميع جهات الاتصال، أو تجربة اسم آخر.",
idleScoped: "لا توجد جهات اتصال مشاركة مع {{scope}} بعد. اعرض كل جهات الاتصال أو أضف واحدة.",
skills: "لا توجد جهات اتصال تتطابق مع هذه المهارات. قم بإيقاف تشغيل مرشح المهارات أو البحث بالاسم.",
search: "لا توجد جهات اتصال متطابقة.",
idle: "اكتب للبحث في جهات الاتصال.",
},
showAllContacts: "إظهار كافة جهات الاتصال",
clearScopeA11y: "امسح مرشح {{scope}} وأظهر جميع جهات الاتصال",
deselectA11y: "قم بإلغاء تحديد {{name}}",
selectA11y: "حدد {{name}}",
selectWithRolesA11y: "حدد {{name}}، والأدوار {{roles}}",
recommendedReason: "موصى به · {{reason}}",
workspaceWide: "الجميع",
teamOnly: "فريقي فقط",
skillsLabel: "المهارات",
clear: "مسح",
clearSkillFiltersA11y: "مسح مرشحات المهارات",
addFilter: "إضافة عامل تصفية",
hide: "إخفاء",
hideSkillListA11y: "إخفاء قائمة مرشحات المهارات",
addSkillFiltersA11y: "أضف مرشحات المهارات",
skillFilterHint: "اختياري: تصفية جهات الاتصال حسب مهارة واحدة أو أكثر.",
removeSkillFilterA11y: "قم بإزالة مرشح {{skill}}",
fromThisJob: "من أمر العمل هذا",
filterBySkillA11y: "تصفية حسب {{skill}}",
searchSkillsPlaceholder: "البحث عن المهارات...",
searchSkillsA11y: "البحث عن المهارات",
noSkillsMatch: "لا توجد مهارات تطابق بحثك.",
addAction: "إضافة",
removeAction: "إزالة",
toggleSkillFilterA11y: "{{action}} مرشح {{skill}}",
selectedCount_zero: "تم تحديد {{count}}",
selectedCount_one: "تم تحديد {{count}}",
selectedCount_two: "تم تحديد {{count}}",
selectedCount_few: "تم تحديد {{count}}",
selectedCount_many: "تم تحديد {{count}}",
selectedCount_other: "تم تحديد {{count}}",
continueLabel: "متابعة",
continueWithA11y: "المتابعة مع {{count}} {{noun}}",
contactNoun_one: "جهة اتصال",
contactNoun_other: "جهة اتصال",
contactNoun_zero: "جهات اتصال",
contactNoun_two: "جهتا اتصال",
contactNoun_few: "جهات اتصال",
contactNoun_many: "جهة اتصال",
},
organisationsField: {
empty: "لم يتم ربط أي منظمات حتى الآن.",
chooseOrganisation: "اختر المنظمة",
primaryA11y: "المنظمة الأساسية",
removeA11y: "إزالة المؤسسة",
titlePlaceholder: "المسمى الوظيفي (مثال: مسؤول الموثوقية)",
titleA11y: "المسمى الوظيفي في المؤسسة",
addA11y: "إضافة المنظمة",
addLabel: "إضافة المنظمة",
pickerTitle: "حدد المنظمة",
},
phonesField: {
empty: "لا توجد أرقام هواتف حتى الآن.",
phoneTypeA11y: "نوع الهاتف {{label}}",
primaryA11y: "الهاتف الأساسي",
removeA11y: "إزالة الهاتف",
addA11y: "إضافة رقم الهاتف",
addLabel: "إضافة هاتف",
},
threeSixty: {
assetSharedTitle: "تمت مشاركة {{asset}} مع {{name}}",
shareSubtitle: "مشاركة · {{status}}",
requestSubtitle: "طلب · {{status}}",
jobFallback: "مهمة",
inspectionLabel: "تفتيش",
contactJoinedTitle: "انضم {{name}} إلى التطبيق",
invitedTitle: "تمت دعوته إلى التطبيق ({{email}})",
invitationSubtitle: "دعوة · {{status}}",
appStandingInApp: "في التطبيق",
appStandingPending: "الدعوة معلقة منذ {{when}}",
appStandingNotInvited: "لم تتم دعوته بعد",
statusActive: "نشط",
lastActivity: "آخر نشاط {{when}}",
noActivityYet: "لا يوجد أي نشاط حتى الآن",
noEmailOrPhone: "لا يوجد بريد إلكتروني أو هاتف في الملف.",
emailA11y: "البريد الإلكتروني {{email}}",
callA11y: "اتصل بـ {{phone}}",
openWork: {
sharedAssets: "الأصول المشتركة",
openRequests: "الطلبات المفتوحة",
openInspections: "التفتيشات المفتوحة",
openJobs: "مهام مفتوحة",
},
openWorkInfo: {
sharedAssetsDesc: "الأصول التي يمكن لجهة الاتصال هذه رؤيتها ورفع الطلبات عليها من خلال مشاركة نشطة.",
sharedAssetsBasedOn: "{{active}} من {{total}} مشاركة ما زالت نشطة، تُحتسب مباشرة",
openRequestsDesc: "الطلبات المقدَّمة من جهة الاتصال هذه أو لها، والتي لم تُغلق أو تُرفض أو تُحوَّل.",
openRequestsBasedOn: "{{open}} من {{total}} طلبًا ما زال مفتوحًا، يُحتسب مباشرة",
openInspectionsDesc: "الفحوصات المرتبطة بجهة الاتصال هذه والتي لم تكتمل بعد.",
openInspectionsBasedOn: "{{open}} من إجمالي {{total}} من الفحوصات المرتبطة، تُحتسب مباشرة",
openJobsDesc: "أوامر العمل غير المكتملة المرتبطة بشكل صريح بجهة الاتصال هذه. قد لا يظهر هنا العمل الذي تم تعيينه فقط من خلال حساب المستخدم الخاص بهم.",
openJobsBasedOn: "{{open}} من إجمالي {{total}} من أوامر العمل المرتبطة، تُحتسب مباشرة",
},
loadingLinkedWork: "جارٍ تحميل العمل المرتبط",
linkedWorkErrorTitle: "تعذر تحميل العمل المرتبط",
openWithName: "العمل المفتوح مع {{name}}",
noOpenWork: "ليس لدى {{name}} عمل مفتوح. لإسناد أمر عمل إليه، افتح أمر العمل واضغط إسناد.",
},
operational: {
tabsLabel: "أقسام جهة الاتصال",
tabs: {
overview: "نظرة عامة",
assets: "الأصول",
requests: "الطلبات",
history: "السجل",
},
sharedAssetsTitle: "الأصول المشتركة",
sharedAssetsEmpty: "لم تتم مشاركة الأصول بعد. قم بمشاركة أحد الأصول للسماح لجهة الاتصال هذه بطلب عمليات التفتيش أو اقتراح أوامر العمل.",
requestsTitle: "الطلبات",
requestsEmpty: "لا توجد طلبات من جهة الاتصال هذه حتى الآن.",
relatedWorkTitle: "العمل المرتبط",
relatedWorkEmpty: "لا توجد أوامر عمل أو عمليات تفتيش ذات صلة حتى الآن.",
notesTitle: "ملاحظات",
notesEmpty: "لا توجد ملاحظات على جهة الاتصال هذه.",
assetLinksTitle: "روابط الأصول",
assetLinksHelper: "ارتباطات على مستوى السجل (ليست مماثلة لمشاركة مساحة العمل).",
assetFallback: "أصل",
jobFallback: "مهمة",
workspaceAccess: "الوصول إلى مساحة العمل",
permissionJobs: "المهام",
permissionInspections: "التفتيش",
permissionDocuments: "المستندات",
scheduleProposedAndScheduled: "المقترح {{proposed}} · المقرر {{scheduled}}",
scheduleScheduled: "المقرر {{scheduled}}",
scheduleProposed: "المقترح {{proposed}}",
statusPrefix: "الحالة {{status}}",
openRequestCount_one: "طلب مفتوح واحد",
openRequestCount_other: "{{count}} طلب مفتوح",
openAssetA11y: "فتح الأصل {{name}}",
requestA11y: "طلب {{title}}",
jobA11y: "أمر العمل {{label}}",
inspectionA11y: "الفحص {{title}}",
shareAsset: "مشاركة الأصل",
shareAssetA11y: "اختر أصلًا لمشاركته",
allRequests: "جميع الطلبات",
allRequestsA11y: "عرض كافة الطلبات",
email: "البريد الإلكتروني",
emailA11y: "مراسلة جهة الاتصال بالبريد الإلكتروني",
invite: "دعوة",
inApp: "في التطبيق",
inviteA11y: "دعوة جهة اتصال",
shareContact: "مشاركة جهة الاتصال",
shareContactA11y: "مشاركة جهة الاتصال مع الفريق",
openRequestCount_zero: "لا طلبات مفتوحة",
openRequestCount_two: "طلبان مفتوحان",
openRequestCount_few: "{{count}} طلبات مفتوحة",
openRequestCount_many: "{{count}} طلبًا مفتوحًا",
},
linkCard: {
unlinkA11y: "إلغاء ربط جهة الاتصال",
otherRole: "أخرى",
contactFallback: "جهة اتصال",
},
inviteLanding: {
  acceptFailed: "تعذّر قبول الدعوة. حاول مرة أخرى أو اطلب دعوة جديدة ممن أرسلها.",
  acceptFailedTitle: "تعذّر قبول الدعوة",
  accepted: "تم. كل ما تتم مشاركته معك يظهر في الرئيسية.",
  expired: "انتهت صلاحية هذه الدعوة. اطلب دعوة جديدة ممن أرسلها.",
  desc: "{{name}}، تمت دعوتك إلى AssetWRX. سجّل الدخول لترى ما تمت مشاركته معك.",
},
};